<template>
    <section>
        <v-btn text class="px-0 green--text back" @click="$router.go(-1)" absolute v-if="$vuetify.breakpoint.mdAndDown">
            <svg v-svg="'icon-back'" size="11" fill="currentColor" class="mr-1"></svg>
            <span>{{$t('global.back')}}</span>
        </v-btn>

        <h1 class="mt-5 mb-3 text-center">{{$t('quizzes.header')}}</h1>

        <v-data-table :headers="headers"
                      :items="RESULTS"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{props.index+1}}
            </template>

            <template v-slot:item.created_at="props">
                {{moment(props.item.created_at).locale(localeDate).format('lll')}}
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0" :to="{name: 'RateQuiz', query: {quiz_id: props.item.id}}">
                    <svg v-svg="'icon-done'" size="12" class="mr-1"></svg>
                    <span style="color: #5bb235">{{props.item.status === 3 || props.item.status === 1  ? $t('quizzes.rate') : $t('quizzes.rated')}}</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        data(){
            return {
                loadingRequest: false,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('results.subject'), sortable: false, value: 'course_name'},
                    {text: this.$t('results.date'), sortable: false, value: 'created_at'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
            }
        },

        computed: {
            ...mapGetters(['RESULTS']),
            localeDate(){
                return this.$i18n.locale === 'am' ? 'hy-am' : 'en';
            },
        },

        mounted(){
            this.getData();
        },

        methods: {
            getData(){
                this.loadingRequest = true;
                this.$store.dispatch('GET_TEACHER_RESULTS', {params: {student_id: this.$route.query.student_id}})
                    .then(() => this.loadingRequest = false);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/tablePages";
</style>